module.exports = __webpack_public_path__ + "static/media/Claremont Dr, San Bruno, CA2.cdd3ccd1.jpg";